import axios from 'axios';
import { API } from '../Common';
let partner_id = localStorage.getItem('partner_id');

var resetPartnerId = function () {
    if (partner_id == null) {
        partner_id = localStorage.getItem('partner_id');
    }
}

export default {

    getConfigs: function (item) {
        return new Promise((resolve, reject) => {
            resetPartnerId();
            axios.get(API + `configs?restaurant_id=${partner_id}`, item)
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    postConfigs: function (batch_config) {
        resetPartnerId();
        batch_config['restaurant_id'] = partner_id;
        return new Promise((resolve, reject) => {
            axios.post(API + `configs_batch/`, batch_config)
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    putConfigs: function (batch_config) {
        resetPartnerId();
        batch_config['restaurant_id'] = partner_id;
        return new Promise((resolve, reject) => {
            axios.put(API + `configs_batch/`, batch_config)
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/api/Config.js